import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  InputGroup,
  Row,
  Form as BForm,
  Spinner,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import { sendEmailSchema } from "../schema";
import BgsImage from "../../../../assets/img/login-image.png";
import leafImage from "../../../../assets/img/leaf.png";
import React from "react";
import { useNavigate } from "react-router-dom";
import { AdminsRoutes } from "../../../../routes";

const TakeUserMail = ({ sendMailLoading, handleSendMail }) => {
  const navigate = useNavigate()
  return (
    <>
      <main>
        <section>
          <div className="leafImage">
            <img src={leafImage} width={100}></img>
          </div>
          <Row className="justify-content-center vh-100">
            <Col
              xs={12}
              md={8}
              className="d-flex align-items-center BGImage justify-content-center"
            >
              <img src={BgsImage} width={500}></img>
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex align-items-center justify-content-center bg-white"
            >
              <div className="bg-white p-2 p-lg-5 w-100">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h2 className="mb-0 login-heading">Forgot Password</h2>
                  <p>No worries, we’ll send you reset instructions!</p>
                </div>

                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={sendEmailSchema}
                  onSubmit={({ email }) => handleSendMail({ email })}
                >
                  {({
                    touched,
                    errors,
                    values,
                    handleChange,
                    handleSubmit,

                  }) => (
                    <div>
                      <Form>
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className={
                              touched.email && errors.email ? "text-danger" : ""
                            }
                          >
                            Email
                          </label>

                          <InputGroup
                            className={
                              touched.email && errors.email
                                ? "border border-danger"
                                : ""
                            }
                          >
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faEnvelope} />
                            </InputGroup.Text>

                            <BForm.Control
                              name="email"
                              autoFocus
                              required
                              type="email"
                              placeholder="example@company.com"
                              value={values.email}
                              onChange={handleChange}
                              
                            />
                          </InputGroup>

                          <ErrorMessage
                            component="div"
                            name="email"
                            className="text-danger"
                          />
                        </div>

                        <div className="d-flex justify-content-end">
                          <p
                            className="mt-1"
                            style={{ color: "#0948b3", cursor: "pointer" }}
                            onClick={() =>
                              navigate(AdminsRoutes?.defaultRoute)
                            }
                          >
                            Go to Sign In
                          </p>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary btn-block mt-4"
                          onClick={handleSubmit}
                        >
                          {sendMailLoading && (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          Reset Password
                        </button>
                      </Form>
                    </div>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </section>
      </main>
    </>
  );
};

export default TakeUserMail;
